"use client";

import { c as _c } from "react/compiler-runtime";
import { useDynamicFaviconAndTitle } from "@local/ui/src/hooks/useDynamicFaviconAndTitle";
interface DynamicFaviconProps {
  favicon?: string;
}
export const DynamicFavicon = t0 => {
  const $ = _c(2);
  const {
    favicon
  } = t0;
  let t1;
  if ($[0] !== favicon) {
    t1 = {
      favicon
    };
    $[0] = favicon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useDynamicFaviconAndTitle(t1);
  return null;
};